(() => {
  function initialize(root = document) {
    const sections = root.matches?.('[data-sgp-compatible]') ? [root] : root.querySelectorAll('[data-sgp-compatible]');
    sections.forEach(section => {
      if (section.dataset.sgpCompatibleReady) return;
      section.dataset.sgpCompatibleReady = '1';
      const container = section.querySelector('.sgp-pdp-compatible-content');
      const loading = section.querySelector('[data-sgp-compatible-loading]');
      const recommendations = container?.querySelector('product-recommendations');
      const link = section.closest('.sgp-pdp-details')?.querySelector('[data-sgp-compatible-link]');
      if (!container || !recommendations) {
        if (loading) loading.remove();
        section.hidden = true;
        if (link) link.hidden = true;
        return;
      }
      let settled = false;
      let timeoutId;
      const observer = new MutationObserver(check);
      const finish = hasProducts => {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        observer.disconnect();
        if (loading) loading.remove();
        if (!hasProducts) {
          section.hidden = true;
          if (link) link.hidden = true;
        } else {
          section.hidden = false;
          if (link) link.hidden = false;
        }
      };
      function check() {
        if (recommendations.querySelector('.swiper-wrapper .swiper-slide')) finish(true);
      }
      observer.observe(recommendations, { childList: true, subtree: true });
      check();
      // Let the theme's existing product-recommendations custom element load normally.
      // If it never loads or returns no items, avoid an endless loading indicator.
      timeoutId = setTimeout(() => finish(!!recommendations.querySelector('.swiper-wrapper .swiper-slide')), 8000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();